<template>
  <div class="swiper-container" id="swiper_container_home_top">
  	<ul class="swiper-wrapper">
  		<li :class="['swiper-slide', isBack?'ss_top':'']" v-for="(item, index) in slide" :key="index"><img :src="item" alt=""></li>
  	</ul>
    <!-- <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div> -->
    <ul class="swiper-pagination">
    	<li class="swiper-pagination-bullet" v-for="(item, index) in slide" :key="index"></li>
    </ul>
  </div>
</template>

<script>
  import Swiper from "./swiper/index.js";
  export default {
    name: "Swiper",
    props: ["slide", "swiperParam", "isBack"],
    mounted:function(){
      if(!this.swiperParam){
        this.swiperParam = {}
      }
      let SwiperFun = Swiper.Swiper;
      var swiper = new SwiperFun('#swiper_container_home_top', this.swiperParam);
    }
  }
</script>

<style lang="less">
  @import url("../../assets/css/swiper.css");
  .swiper-container {
    width: 100%;
    max-height: 100vh;
    .swiper-wrapper {
      width: 100%;
      padding: 0;
      margin: 0;
      .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        img {
          display: block;
          width: 100%;
        }
      }
      .ss_top {
        &:after {
          content: '';
          display: block;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
          z-index: 999;
          top: 0;
          left: 0;
        }
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      color: white;
    }
    .swiper-pagination-bullet {
      opacity: 0.5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Swiper.vue